module.exports = __webpack_public_path__ + "assets/assets/images/icons/attachment_icon.9ea213f2.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/icons/attachment_icon.svg
// module id = 529
// module chunks = 0